import { HrTabs } from "./models/hr.model";

export type HrTabKey = keyof HrTabs;

export interface HrTabDefinition {
  key: HrTabKey;
  /**
   * Segmento do URL. Separado da chave porque nem sempre coincidem
   * (`jobOpenings` vive em `/hr/job-openings`).
   */
  route: string;
  label: string;
  icon: string;
}

/**
 * As páginas de Recursos Humanos, pela ordem do submenu. É a mesma lista para
 * o submenu do sidebar e para o cabeçalho de /hr — quem as pode ver decide-o
 * o servidor (`/hr/meta`).
 */
export const HR_TABS: HrTabDefinition[] = [
  { key: "overview", route: "overview", label: "t-hr.tabs.overview", icon: "ri-dashboard-line" },
  { key: "recruitment", route: "recruitment", label: "t-hr.tabs.recruitment", icon: "ri-user-search-line" },
  { key: "jobOpenings", route: "job-openings", label: "t-hr.tabs.job-openings", icon: "ri-briefcase-line" },
  { key: "vacations", route: "vacations", label: "t-hr.tabs.vacations", icon: "ri-calendar-check-line" },
  { key: "shifts", route: "shifts", label: "t-hr.tabs.shifts", icon: "ri-time-line" },
  { key: "users", route: "users", label: "t-hr.tabs.users", icon: "ri-contacts-book-line" },
  { key: "settings", route: "settings", label: "t-hr.tabs.settings", icon: "ri-settings-3-line" },
];

/**
 * Abas escondidas do submenu do sidebar (só display none). As páginas e o
 * acesso por URL ficam iguais; tirar daqui volta a mostrá-las.
 */
export const HR_HIDDEN_MENU_KEYS: HrTabKey[] = [
  "overview",
  "vacations",
  "jobOpenings",
  "shifts",
  "users",
  "settings",
];

/** O link do item de RH no menu (a linha `menus` com este `link`). */
export const HR_MENU_LINK = "/hr";
